/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/* global document */

import $ from 'jquery';
import { setupHighlight } from './_highlight';
import { enableCollapsables, hideTogglers } from './_collapsables';
import { enableAnchors } from './_anchors';
import { enableDropdowns } from './_dropdowns';
import { enableFiltering } from './_filtering';
import { trackArticlePosition } from './_toc';
import { expandApiTree, scrollApiTree } from './_apitree';
import { setUpFuse } from './_apisearch';
import pageNavigation from './_pagenavigation';
import { activateDevNames } from './_devnames';
import sideNavigation from './_sidenavigation';
import sampleCode from './_samplecode';
import copyMobileApiNavigation from './_copymobileapinavigation';
import { rwdButton } from './_rwdmenu';
import imageModal from './_imageModal';

$( document ).ready( () => {
	pageNavigation(); // pageNavigation - needs to be run before filtering initialization.
	copyMobileApiNavigation(); // copy API Tree into mobile navigation
	enableFiltering();
	setupHighlight();
	expandApiTree();
	enableCollapsables();
	hideTogglers();
	enableAnchors();
	enableDropdowns();
	trackArticlePosition();
	scrollApiTree();
	setUpFuse();
	activateDevNames();
	sampleCode(); // control accordion of sample code and buttons(copy/download)
	sideNavigation();
	rwdButton();

	imageModal(); // lightbox for { @img } elements
} );
